<template>
  <div id="main-footer" class="item">
    <div class="footer-text">
      <div class="footer-top">
        <span class="footer-top-title">联系我们</span>
        <span class="footer-top-text">Contact Us</span>
      </div>
      <div class="main-bottom">
        <div class="main-container">
          <div class="main-container-item">
            <div class="container-item">
              <img :src=dhPage alt="">
              <span class="main-bottom-title">联系电话</span>
            </div>
            <span class="main-bottom-text">029-68790192</span>
          </div>
          <div class="main-container-item">
            <div class="container-item">
              <img :src=emailPage alt="">
              <span class="main-bottom-title">企业邮箱</span>
            </div>
            <span class="main-bottom-text">xafyun@163.com</span>
          </div>
          <div class="main-container-item">
            <div class="container-item">
              <img :src=dzPage alt="">
              <span class="main-bottom-title">公司地址</span>
            </div>
            <span class="main-bottom-text">陕西省西安是雁塔区,逸翠园i都会3号楼,1009室</span>
          </div>
        </div>
        <img :src=mapPage alt="">
      </div>
      <div class="main-footer-text">
        <a href="https://beian.miit.gov.cn/" target="_blank">陕ICP备2022014190号-1</a>
        <span>Copyright@02022伏云智维(西安)科技有限公司 All rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
import dzPage from "@/assets/image/dz.png";
import dhPage from "@/assets/image/dh.png";
import mapPage from "@/assets/image/map.png";
import emailPage from "@/assets/image/email.png";
import footrebgPage from "@/assets/image/footerbg.png";
export default {
  name: "FooterPage",
data(){
  return{
    footrebgPage,dzPage,dhPage,mapPage,emailPage,
  }
}
}
</script>

<style lang="scss" scoped>
#main-footer{
  width: 100%;
  height: 420px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #051f39;
  margin-bottom: 12px;
  .footer-text{
    width: 60%;
    padding: 12px;
    .footer-top{
      display: flex;
      width: 100%;
      flex-direction: column;
      border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
      gap: 4px;
      padding-bottom: 24px;
      .footer-top-title{
        font-family: 'PingFang SC';
        font-weight: 500;
        font-size: 28px;
        color: #FFFFFF;
      }
      .footer-top-text{
        font-family: 'FF DIN Pro';
        font-weight: 500;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.6);
      }
    }
    .main-bottom{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 28px;
      .main-container{
        display: flex;
        flex-direction: column;
        gap: 12px;
        .main-container-item{
          display: flex;
          flex-direction: column;
          gap: 4px;
          .container-item{
            display: flex;
            gap: 4px;
            align-items: center;
            img{
              width: 12px;
              height: 12px;
            }
            .main-bottom-title{
              font-family: 'PingFang SC';
              font-weight: 500;
              font-size: 12px;
              //line-height: 20px;
              color: #FFFFFF;
            }
          }
        }
        .main-bottom-text{
          font-family: 'FF DIN Pro';
          font-weight: 700;
          font-size: 14px;
          color: #FFFFFF;
        }
      }
      img{
        width: 694px;
        height: 160px;
      }
    }
    .main-footer-text{
      display: flex;
      justify-content: center;
      gap: 12px;
      padding-top: 20px;
      left: 30%;
      span{
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
      }
      a{
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
      }
    }
  }
}
</style>